export enum BalanceTransactionType {
  CREDITING_FUNDS,
  DEBIT,
  CREDIT,
  TRANSFER
}

export const balanceTransactionType = (value: BalanceTransactionType): string => {
  return BalanceTransactionType[value]
}

export enum PaymentStatus {
  PROCESSING,
  VALIDATED,
  PAID,
  REJECTED,
  RETURNED
}

export enum PocketMovementType {
  CREDITING_FUNDS,
  DEBIT,
  CREDIT,
  TRANSFER
}

export enum PaymentTagType {
  BLACK_LISTED,
  TO_CONFIRM_ID_TYPE,
  TO_CONFIRM_BANKING_PARTNER,
  TO_CONFIRM_ORIGIN_OF_FUNDS_MONTHLY,
  TO_CONFIRM_ORIGIN_OF_FUNDS_DAILY,
  TO_CONFIRM_ORIGIN_OF_FUNDS_WEEKLY,
  TO_CONFIRM_PREVIOUS_PAYMENT_WAITING_FOR_RESOLUTION
}

export enum SupportTicketStatus {
  OPEN,
  CLOSED
}

export enum PaymentWithNoveltiesType {
  WITH_FINDINGS,
  GENERAL_ALERT,
  HARD_STOP
}

export enum ReportStatus {
  PROCESSING,
  COMPLETED,
  ERROR
}

export enum CryptoTransactionStatus {
  PENDING,
  CONFIRMED,
  FAILED
}

export const paymentStatus = (value: PaymentStatus): string => {
  return PaymentStatus[value]
}
